const EVALUATION_ZERO_THRESHOLD = 0.01;

type Params = {
	totalValue: number;
	totalInvestedValue: number;
	totalEvaluationPercent: number;
};

export const getChartValueMetrics = ({
	totalValue,
	totalInvestedValue,
	totalEvaluationPercent,
}: Params) => {
	const investmentResult = totalValue - totalInvestedValue;

	const evaluationPercent =
		Math.abs(totalEvaluationPercent) <= EVALUATION_ZERO_THRESHOLD
			? 0
			: totalEvaluationPercent;

	return {
		investmentResult,
		evaluationPercent,
		isPositive: evaluationPercent > 0 || investmentResult > 0,
		isZeroInvestmentRatio: evaluationPercent === 0,
	};
};
